module.exports = __webpack_public_path__ + "static/media/info-card-3.b864ffab.png";